import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28f3677e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pptist-editor" }
const _hoisted_2 = {
  key: 0,
  class: "my-spin"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "my-spin"
}
const _hoisted_6 = {
  class: "loading",
  style: {"position":"relative","left":"auto","color":"#008aff"}
}
const _hoisted_7 = { class: "layout-content-center" }
const _hoisted_8 = {
  name: "slide-fade",
  style: {"position":"relative"}
}
const _hoisted_9 = { class: "left_div" }
const _hoisted_10 = {
  key: 2,
  class: "progress-div"
}
const _hoisted_11 = { class: "btn-list" }
const _hoisted_12 = { style: {"display":"flex","flex-wrap":"wrap","align-items":"center","justify-content":"space-between","padding":"10px 1rem"} }
const _hoisted_13 = { style: {"padding-top":"8px","font-size":"12px"} }
const _hoisted_14 = { style: {"display":"flex"} }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1698669928246",
  class: "icon ml-1",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "7503",
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M729.6 448H128v85.333333h601.6L597.333333 665.6l59.733334 59.733333 234.666666-234.666666L661.333333 256l-59.733333 59.733333 128 132.266667z",
    fill: "#ffffff",
    "p-id": "7504"
  })
], -1))
const _hoisted_16 = { class: "category-list" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"border-top":"1px solid #dbe1ff","height":"1px","margin":"0px 1rem 0.5rem"} }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1735354658805",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "7087",
  width: "32",
  height: "32"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M965.818182 453.818182H570.181818V58.181818a58.181818 58.181818 0 0 0-58.181818-58.181818 58.181818 58.181818 0 0 0-58.181818 58.181818v395.636364H58.181818a58.181818 58.181818 0 0 0-58.181818 58.181818 58.181818 58.181818 0 0 0 58.181818 58.181818h395.636364v395.636364a58.181818 58.181818 0 0 0 58.181818 58.181818 58.181818 58.181818 0 0 0 58.181818-58.181818V570.181818h395.636364a58.181818 58.181818 0 0 0 58.181818-58.181818 58.181818 58.181818 0 0 0-58.181818-58.181818z",
    "p-id": "7088",
    fill: "#ffffff"
  })
], -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "pvImg-content" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "preview" }

import { onBeforeUnmount, onMounted, ref, watch, h } from "vue";
import {
  Spin,
  Modal,
  notification,
  Button,
  Progress,
  message,
  Row,
  Col,
} from "ant-design-vue";
import {
  uploadFileToOSS,
} from "@/utils/uploadOss";
import { RightOutlined, LeftOutlined } from "@ant-design/icons-vue";
import useClipboard from "vue-clipboard3";
import { storeToRefs } from "pinia";
import { useMainStore, useSlidesStore } from "@/store";

import useGlobalHotkey from "@/hooks/useGlobalHotkey";
import usePasteEvent from "@/hooks/usePasteEvent";
import useSlideHandler from "@/hooks/useSlideHandler";
import {
  getUserPptInfo,
  getPageContent,
  getNewPageContent,
  getPageContentByKey,
  getPageDisContent,
  uploadFile,
  updateImg,
  getSliderInfoList,
  savePptInfo,
  savePptInfoV2,
  getUserCanChatAndDownLoad,
  getTemplateList,
  changeTemplate,
  saveClickData,
  setPptShareAuth,
  getPreviewJson,
  getPptThemeStyleByLanguage,
} from "@/api/combo";
import { Slide } from "@/types/slides";
import { getToken } from "@/utils/auth";
import EditorHeader from "./EditorHeader/index.vue";
import Canvas from "./Canvas/index.vue";
import CanvasTool from "./CanvasTool/index.vue";
import NewCanvasTool from "./NewCanvasTool/index.vue";
import Thumbnails from "./Thumbnails/index.vue";
import Toolbar from "./Toolbar/index.vue";
import NewToolbar from "./NewToolbar/index.vue";
import Remark from "./Remark/index.vue";
import ExportDialog from "./ExportDialog/index.vue";
import SelectPanel from "./SelectPanel.vue";
import Redraw from "./Redraw/index.vue";
import Cookies from "js-cookie";
import { sendClickData, getQueryString } from "@/utils/common";

import useCreateElement from "@/hooks/useCreateElement";
import { useI18n } from "vue-i18n";
import html2canvas from "html2canvas";

/* stop generate start */
interface DelayLoading {
  delay: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { selectAllSlide, createSlideByInfo, deleteSlide, replaceSlide } =
  useSlideHandler();
const { createElement, createElementAfter } = useCreateElement();

const { t, locale } = useI18n();
const stop = ref(false);
const isEnd = ref(false);
const userSelectPreCatalogueId = ref(0);
const layoutContent: any = ref(null);
let index = 0;

const waitTime = ref(0);
const reWaitTime = () => {
  waitTime.value = waitTime.value - 1;
  if (waitTime.value > 0) {
    setTimeout(function () {
      reWaitTime();
    }, 1000);
  }
};
const enterIconLoading = () => {
  if (waitTime.value === 0) {
    waitTime.value = 20;
    reWaitTime();
  }
  stop.value = true;
  spinning.value = false;
};
const mainStore = useMainStore();
const slidesStore = useSlidesStore();
const {
  dialogForExport,
  showSelectPanel,
  activeElementIdList,
  redrawFlag,
  isAiGenerating,
  isPc,
  pptId,
  ossUrl
} = storeToRefs(mainStore);
const { slideIndex, currentSlide } = storeToRefs(slidesStore);
const closeExportDialog = () => mainStore.setDialogForExport("");
const canvasWidth = ref("cale(100% - 70px)");
/* stop generate end */
const tip = ref(t(`index.createText`)); // '正在生成PPT文案'
const spinning = ref(false); //加载中
const errSpinning = ref(false);
const goChangeMsgModalShow = ref(false);
const prompt = ref();
const sessionId = ref(0);
const recordId = ref();
const paid = ref();
const key = ref("");
const timer = ref();
const bg = ref();
const slideList = ref<any>([]);
const tokenOver = ref(false);
const isSaveFlag = ref(false);
const defaultPercent = ref<number>(0);
const progressTimer = ref();
const pageSize = ref<number>(50);
const mouseenterFlag = ref(true);
const canChat = ref(false);
const canDownLoad = ref(false);
const isVip = ref(false);
const hasPptHeadImg = ref(false);
// 替换模版时不需要保存首页图片
const saveHeadImg = ref(true);
const getPagePartialContentBegin = ref(); //5秒后不再请求
const elRight: any = ref(80);
const elTop: any = ref(80);
const bodyWidth: any = ref();
const bodyHeight: any = ref();
const startclientX: any = ref(); //元素初始位置
const startclientY: any = ref();
const touchStartRight: any = ref();
const touchStartTop: any = ref();
const nowSize: any = ref();
const toolShow: any = ref(false);
const rightToolShow: any = ref(false);
const backgroundEditSate: any = ref(false);
const pageType = ref<string | number>(3); //生成页数类型
const themeId = ref();

onBeforeUnmount(() => {
  if (!timer.value) {
    spinning.value = false;
    clearInterval(timer.value);
  }
});

const changeToolShow = (data: boolean, type: number = 0): void => {
  backgroundEditSate.value = Boolean(type && data); //点击背景的展示背景编辑
  rightToolShow.value = data;
};
const canMove = ref(false);
const moveTimer: any = ref(null);
const touchstart = (e: any) => {
  moveTimer.value && clearTimeout(moveTimer.value);
  moveTimer.value = setTimeout(() => {
    canMove.value = true;
  }, 1000);
  startclientX.value = e.targetTouches[0].pageX; //记录拖动开始初始位置
  startclientY.value = e.targetTouches[0].pageY;
  touchStartRight.value = elRight.value; // 记录拖拽元素初始位置
  touchStartTop.value = elTop.value;
};

const touchmove = (e: any) => {
  let x = e.targetTouches[0].pageX - startclientX.value; // 计算偏移量
  let y = e.targetTouches[0].pageY - startclientY.value;
  if ((Math.abs(x) > 20 || Math.abs(y) > 20) && moveTimer.value) {
    clearTimeout(moveTimer.value);
  }
  if (!canMove.value) {
    return;
  }
  e.preventDefault(); //阻止内部滑动事件
  elRight.value = touchStartRight.value - x; // 实现拖拽元素随偏移量移动
  elTop.value = touchStartTop.value + y;
};

const touchend = (e: any) => {
  moveTimer.value && clearTimeout(moveTimer.value);
  canMove.value = false;
};

const dragstart = (e: any) => {
  startclientX.value = e.clientX; // 记录拖拽元素初始位置
  startclientY.value = e.clientY;
};

const dragend = (e: any) => {
  let x = e.clientX - startclientX.value; // 计算偏移量
  let y = e.clientY - startclientY.value;
  elRight.value -= x; // 实现拖拽元素随偏移量移动
  elTop.value += y;
};
const ppt_start_Y: any = ref(0);
const pptTouchstart = (e: any) => {
  ppt_start_Y.value = e.touches[0].clientX;
};
const pptTouchend = (e: any) => {
  var ppt_end_Y = e.changedTouches[0].clientX;
  let len = slidesStore.slides.length;
  if (Math.abs(ppt_start_Y.value - ppt_end_Y) < 20) return;
  if (ppt_start_Y.value > ppt_end_Y && len > slideIndex.value + 1) {
    slidesStore.updateSlideIndex(slideIndex.value + 1);
  }
  if (ppt_start_Y.value < ppt_end_Y && slideIndex.value > 0) {
    slidesStore.updateSlideIndex(slideIndex.value - 1);
  }
};

const userIsPc = () => {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return !flag;
};

onMounted(() => {
  getThemeList();
  var url = decodeURIComponent(location.search.substring(1));
  var params: any = {};
  url.split("&").forEach(function (item) {
    var kv = item.split("=");
    params[kv[0]] = kv[1];
  });
  const { token } = params;
  token && localStorage.setItem("token", token);
  mainStore.setIsPc(layoutContent.value.clientWidth > 767);
  nowSize.value = layoutContent.value.clientWidth;
  window.addEventListener("resize", () => {
    if (layoutContent.value) {
      nowSize.value = layoutContent.value.clientWidth;
      mainStore.setIsPc(layoutContent.value.clientWidth > 767);
    }
  });
  bodyWidth.value = layoutContent.value.clientWidth;
  bodyHeight.value = layoutContent.value.clientHeight;
  // 未登录
  if (!getToken()) {
    message.error(t("public.loginTips"), 30);
    return;
  }
  // 防止有PPT数据时刷新页面
  if (slidesStore.slideList.length !== 0 || slidesStore.slides.length !== 0) {
    recordId.value = pptId.value;
    getAuths();
    spinning.value = false;
    isEnd.value = true;
    return;
  }
  const urlSearch = window.location.search;
  recordId.value = getQueryString("recordId", urlSearch);
  const urlFlowId = getQueryString("flowId", urlSearch);
  pageType.value = getQueryString("pageType", urlSearch) || 3;
  userSelectPreCatalogueId.value = Number(
    getQueryString("userSelectPreCatalogueId", urlSearch)
  );
  const paramId = urlFlowId ? urlFlowId : recordId.value;

  getPagePartialContentBegin.value = Math.floor(Date.now() / 1000);
  if (!paramId) {
    notification["error"]({
      message: "System is busy.",
      // description: t('errorCode.errMsg'),
    });
    return;
  } else {
    mainStore.setPptId(paramId);
  }
  spinning.value = true;
  getAuths();
  getUserPptInfo(paramId).then((res) => {
    if (res.data) {
      const data = res.data;
      hasPptHeadImg.value = data.img ? true : false;
      userSelectPreCatalogueId.value = data.prePptDataId;
      paid.value = data.paid;
      themeId.value = data.themeId;
      recordId.value = paramId;
      if (window.location.href.includes("admin")) {
        isVip.value = data.isVip;
      }
      if (themeId.value) {
        getTemplateLayouts();
      }
      if (data.loaded == 0) {
        index = 0;
        initPptNew();
      } else {
        index = 1;
        getSliderList(paramId);
      }
    } else {
      index = 0;
      initPptNew();
    }
  });
  /* index = 0
  initPptNew(); */
});

const getUserPptInfoAgain = () => {
  getUserPptInfo(pptId.value).then((res) => {
    if (res.data) {
      const data = res.data;
      hasPptHeadImg.value = data.img ? true : false;
      userSelectPreCatalogueId.value = data.prePptDataId;
      paid.value = data.paid;
      themeId.value = data.themeId;
    }
  });
};

const getTemplateLayouts = async () => {
  try {
    const res = await getPreviewJson({ id: themeId.value });
    let emptyArr: Slide[] = [];
    if (Array.isArray(res.data)) {
      for (const slide of res.data) {
        let item = JSON.parse(slide)
        if (item.background) {
          if (item.background.type === "image" && item.background.image && !isBase64Image(item.background.image) && !item.background.image.includes("https://")) {
            item.background.image = `${ossUrl.value}${item.background.image}`;
          }
          if (!item.elements) continue;
          for (const el of item.elements) {
            if (el.type === "image" && el.src && !isBase64Image(el.src) && !el.src.includes("https://")) {
              el.src = `${ossUrl.value}${el.src}`;
            }
          }
        }
        emptyArr.push(item);
      }
    }
    slidesStore.setTemplateLayouts(emptyArr);
  } catch (error) { }
};

const addElementToAppointPage = async (element: any, appointIdx: number) => {
  // spinning.value = true
  await pptElementRenderToAppointPage(element, appointIdx);
};
const pptElementRenderToAppointPage = (elements: any, index: any) => {
  const thumbnailList = document.getElementById("thumbnails");
  if (thumbnailList) {
    let len = slideList.value.length;
    thumbnailList.scrollTop = thumbnailList.scrollHeight * (index / len);
    thumbnailList.scrollLeft = thumbnailList.scrollWidth * (index / len);
  }
  for (let i = 0; i < elements.length; i++) {
    const element = elements[i];
    setTimeout(() => {
      slidesStore.slideIndex = index;
      createElement(element);
      // createElementAfter(element,index)
      // if (i === elements.length - 1) {
      //   mainStore.setActiveElementIdList([])
      // }
    }, bandingSpeed.value * (i + 1));
  }
};

const getSliderListAfter = async (id: any) => {
  spinning.value = true;
  const res: any = await getSliderInfoList({
    id,
    pageNum: 1,
    pageSize: pageSize.value,
  });
  const { code, data, total } = res;
  if (data.length) {
    var pptList: Slide[] = [];
    data.forEach((item: any, index: number) => {
      if (item.content) {
        const pptData = JSON.parse(item.content);
        if (pptData.background.type === "image" && pptData.background.image && !pptData.background.image.includes("https://") && !isBase64Image(pptData.background.image)) {
          pptData.background.image = `${ossUrl.value}${pptData.background.image}`;
        }
        if (pptData.background) {
          bg.value = pptData.background;
        } else {
          bg.value = {
            type: 'solid',
            color: '#ffffff',
          };
        }
        pptData.elements.forEach((ele: any) => {
          if (ele.left) ele.left = Number(ele.left);
          if (ele.top) ele.top = Number(ele.top);
          if (ele.width) ele.width = Number(ele.width);
          if (ele.height) ele.height = Number(ele.height);
          if (ele.type === "image" && ele.src && !ele.src.includes("https://") && !isBase64Image(ele.src)) {
            ele.src = `${ossUrl.value}${ele.src}`;
          }
        });
        const emptySlide: Slide = {
          id: pptData.id,
          elements: pptData.elements,
          background: bg.value,
        };
        pptList.push(emptySlide);
      }
    });
    if (pptList.length) {
      slideList.value = pptList;
      replaceSlide(pptList);
    }
    spinning.value = false;
  } else {
    spinning.value = false;
  }
};

const getSliderList = async (id: any) => {
  if (isEnd.value) return;
  const res: any = await getSliderInfoList({
    id,
    pageNum: index,
    pageSize: pageSize.value,
  });
  const { code, data, total } = res;
  if (code === 200) {
    if (total === 0 || total === slideList.value.length || data.length == 0) {
      isEnd.value = true;
      spinning.value = false;
      slidesStore.setSlideList(slideList.value);
      slidesStore.slideIndex = 0;
      const thumbnailList = document.getElementById('thumbnails');
      if (thumbnailList) {
        thumbnailList.scrollTop = 0;
        thumbnailList.scrollLeft = 0;
      }
      return;
    }
    for (let i = 0; i < pageSize.value; i++) {
      const item = data[i];
      if (item && item.ossFlag && item.ossFlag != 2) mainStore.setOssUrl('')
      if (item && item.content) {
        const pptData = JSON.parse(item.content);
        if (pptData.background) {
          bg.value = pptData.background;
        } else {
          bg.value = {
            type: 'solid',
            color: '#ffffff',
          };
        }
        createSlideByInfo(pptData.id, pptData.elements, bg.value);
        if (index === 1) {
          slidesStore.slideIndex = i;
        } else {
          slidesStore.slideIndex = pageSize.value * (index - 1) + i;
        }
        tip.value = t(`index.createPage`, [index + 1]);
        slideList.value.push(pptData);
        const thumbnailList = document.getElementById('thumbnails');
        if (thumbnailList) {
          thumbnailList.scrollTop = thumbnailList.scrollHeight;
          thumbnailList.scrollLeft = thumbnailList.scrollWidth;
        }
        if (total === slideList.value.length) {
          slidesStore.setSlideList(slideList.value);
          slidesStore.slideIndex = 0;
          if (!hasPptHeadImg.value) {
            await setTimeout(() => {
              updateCover('viewport-wrapper');
              isEnd.value = true;
              spinning.value = false;
              const thumbnailList = document.getElementById('thumbnails');
              if (thumbnailList) {
                thumbnailList.scrollTop = 0;
                thumbnailList.scrollLeft = 0;
              }
            }, 500);
          }
        }
      }
    }
    setTimeout(() => {
      index++;
      getSliderList(id);
    }, 1200);
  } else {
    spinning.value = false;
  }
};
const recordPptElementRender = (elements: any) => {
  Cookies.set(key.value + "index", index + ""); // 生成到第几页
  for (let i = 0; i < elements.length; i++) {
    const element = elements[i];
    setTimeout(() => {
      createElement(element);
      if (i === elements.length - 1) {
        index++;
        getSliderList(pptId.value);
      }
    }, 500 * (i + 1));
  }
};

const initPptNew = () => {
  getPagePartialContentBegin.value = Math.floor(Date.now() / 1000);
  isEnd.value = false;
  indexArr.value = [];
  indexArr.value.push(0);
  mainStore.setGenerateState(true);
  // const urlParams = new URLSearchParams(window.location.search)
  // const urlFlowId = urlParams.get('flowId') ? urlParams.get('flowId') : recordId.value
  // userSelectPreCatalogueId.value = Number(urlParams.get('userSelectPreCatalogueId'))
  // prompt.value = urlParams.get('prompt')
  const urlSearch = window.location.search;
  // recordId.value = getQueryString('recordId', urlSearch)
  // const urlFlowId = getQueryString('flowId', urlSearch) ? getQueryString('flowId', urlSearch) : recordId.value
  userSelectPreCatalogueId.value = Number(
    getQueryString("userSelectPreCatalogueId", urlSearch)
  );
  prompt.value = getQueryString("prompt", urlSearch);
  // Cookies.set('flowIdKey' + urlFlowId, urlFlowId + '')
  mainStore.setSessionId(sessionId.value + "");
  // key.value = urlFlowId + ''
  key.value = pptId.value;
  // spinning.value = true
  tip.value = t(`index.createPage`, [index + 1]);
  // Cookies.set('ppt' + urlFlowId + 'prompt', prompt.value)
  // Cookies.set('ppt' + urlFlowId + 'key', key.value)
  // 生成到第N页
  Cookies.set(key.value + "index", "0");
  getPptContent(key.value);
};

const getPptContent = (key: any) => {
  let getPagePartialContentEnd = Math.floor(Date.now() / 1000);
  let stopFlag =
    getPagePartialContentEnd - getPagePartialContentBegin.value > 180;
  if (stopFlag) {
    notification.open({
      message: t(`public.systemMsg`),
      description: t(`public.systemBusy`),
      style: {
        borderRadius: "0.75rem",
        marginLeft: `${335 - 600}px`,
        marginTop: "30px",
      },
      duration: 0,
      class: "notification-custom-class",
    });
    spinning.value = false;
    mainStore.setGenerateState(false);
    isEnd.value = true;
    console.log("stopFlag");
    return;
  }
  const urlSearch = window.location.search;
  const urlKey = getQueryString("flowId", urlSearch);
  // const urlParams = new URLSearchParams(window.location.search)
  // const urlKey = urlParams.get('flowId')
  const needCleanTimer = Cookies.get(urlKey + "-cleanTimer");
  if (needCleanTimer !== null && needCleanTimer) {
    clearInterval(timer.value);
    Cookies.remove(urlKey + "-cleanTimer");
    spinning.value = false;
    mainStore.setGenerateState(false);
    console.log("needCleanTimer");
    return;
  }
  // user stop
  if (stop.value) {
    console.log("stop.value");
    return;
  }
  getPageContent({
    key,
    index: index,
  })
    .then((resContent: any) => {
      const data = resContent.data;
      indexArr.value[index]++;
      if (data.error) {
        indexArr.value = [];
        notification.error({
          message: t(`index.haveProblem`),
          description: data.error,
          duration: null,
        });
        console.log("data.error");
        return;
      }
      if (data.haveContent) {
        getPagePartialContentBegin.value = Math.floor(Date.now() / 1000);
        if (data.background) {
          bg.value = data.background;
        } else {
          bg.value = {
            type: "solid",
            color: "#ffffff",
          };
        }
        createSlideByInfo(data.id, [], bg.value); //添加空白页
        slidesStore.slideIndex = index;
        pptElementRender(data.elements); //添加ppt元素
        tip.value = t(`index.createPage`, [index + 1]);
        slideList.value.push(data);
        const thumbnailList = document.getElementById("thumbnails");
        if (thumbnailList) {
          thumbnailList.scrollTop = thumbnailList.scrollHeight;
          thumbnailList.scrollLeft = thumbnailList.scrollWidth;
        }
      } else {
        let getPagePartialContentEnd = Math.floor(Date.now() / 1000);
        let stopFlag =
          getPagePartialContentEnd - getPagePartialContentBegin.value < 180;
        if (!data.isEnd && stopFlag) {
          setTimeout(function () {
            getPptContent(key);
          }, 1500);
        } else {
          isEnd.value = true;
          spinning.value = false;
        }
      }
      if (data.isEnd || stop.value) {
        indexArr.value = [];
        mainStore.setGenerateState(false);
        isEnd.value = true;
        spinning.value = false;
        slidesStore.slideIndex = 0;
        const thumbnailList = document.getElementById("thumbnails");
        if (thumbnailList) {
          thumbnailList.scrollTop = 0;
          thumbnailList.scrollLeft = 0;
        }
        // getPagePartialContentBegin.value = Math.floor(Date.now() / 1000)
        // getPagePartialContent(key)
        if (data.indexOfs && saveHeadImg.value) {
          getUserPptInfoAgain();
          // if (pageType.value == 3) {//不是第三档不获取目录页
          //   reGetCataloguePage(key, data.indexOfs)
          //   console.log('getCataloguePage');
          // } else {
          //   resetPageSort(key, data.indexOfs)
          //   console.log('no getCataloguePage');
          // }
          getSliderListAfter(key);
        }
        if (!saveHeadImg.value) {
          notification.open({
            message: t(`public.systemMsg`),
            description: t(`public.templateReplaceSuccess`),
            style: {
              borderRadius: "0.75rem",
              marginLeft: `${335 - 600}px`,
              marginTop: "30px",
            },
            duration: 0,
            class: "notification-custom-class",
          });
        }
        saveHeadImg.value = true;
      }
    })
    .catch((e) => {
      setTimeout(function () {
        getPptContent(key);
      }, 1500);
    });
};

// 重新获取目录页并绑定
const reGetCataloguePage = (key: any, indexOfsPrams: any) => {
  getPageContent({
    key,
    index: 1,
  }).then((resContent: any) => {
    const data = resContent.data;
    if (data.error) {
      notification.error({
        message: t(`index.haveProblem`),
        description: data.error,
        duration: null,
      });
      return;
    }
    if (data.haveContent) {
      if (data.background) {
        bg.value = data.background;
      } else {
        bg.value = {
          type: "solid",
          color: "#ffffff",
        };
      }
      slidesStore.deleteSlide(data.id);
      slidesStore.slideIndex = 0;
      createSlideByInfo(data.id, data.elements, bg.value);
      slidesStore.setSlideList(slideList.value);
      const thumbnailList = document.getElementById("thumbnails");
      if (thumbnailList) {
        thumbnailList.scrollTop = 0;
        thumbnailList.scrollLeft = 0;
      }
      // getPagePartialContent(key)
      // 调整顺序
      let indexOfs = JSON.parse(indexOfsPrams);
      let tempSlideList: any[] = [];
      let indexOfsLength = indexOfs.length;
      for (let index = 0; index < indexOfs.length; index++) {
        const element = Number(indexOfs[index]);
        const item = slideList.value[element];
        tempSlideList.push(item);
        if (index == indexOfsLength - 1) {
          slideList.value = tempSlideList;
          slidesStore.setSlides(tempSlideList);
          for (let indexFor = 0; indexFor < indexOfs.length; indexFor++) {
            slidesStore.updateSlideIndex(indexFor);
            if (indexFor == indexOfsLength - 1) {
              slidesStore.updateSlideIndex(1);
            }
          }
        }
      }
    }
  });
};
// 不请求直接排序
const resetPageSort = (key: any, indexOfsPrams: any) => {
  let indexOfs = JSON.parse(indexOfsPrams);
  let tempSlideList: any[] = [];
  let indexOfsLength = indexOfs.length;
  for (let index = 0; index < indexOfs.length; index++) {
    const element = Number(indexOfs[index]);
    const item = slideList.value[element];
    tempSlideList.push(item);
    if (index == indexOfsLength - 1) {
      slideList.value = tempSlideList;
      slidesStore.setSlides(tempSlideList);
      for (let indexFor = 0; indexFor < indexOfs.length; indexFor++) {
        slidesStore.updateSlideIndex(indexFor);
        if (indexFor == indexOfsLength - 1) {
          slidesStore.updateSlideIndex(1);
        }
      }
    }
  }
};
const getPagePartialContent = async (key: any) => {
  mainStore.setGenerateState(true);
  spinning.value = true;
  const res: any = await getPageDisContent({ key });
  let objIdx = 0;
  if (res.data.content && JSON.stringify(res.data.content) != "{}") {
    let content = res.data.content;
    let maxEleLen = 0;
    for (var i in content) {
      objIdx++;
      let element = JSON.parse(content[i]);
      let idx = Number(i);
      let timeIdx = objIdx;
      if (element.length > maxEleLen) maxEleLen = element.length;
      setTimeout(() => {
        pptElementRenderToAppointPage(element, idx);
      }, bandingSpeed.value * 4 * (timeIdx + 1));
      if (Object.keys(content).length == objIdx) {
        setTimeout(() => {
          if (!res.data.isEnd) {
            getPagePartialContent(key);
          }
          mainStore.setGenerateState(false); //选中元素时是否有工具栏
          mainStore.setActiveElementIdList([]);
          slideList.value = slidesStore.slides; //将最新数据同步到当前页面参数
          slidesStore.setSlideList(slidesStore.slides);
          slidesStore.slideIndex = 0;
          const thumbnailList = document.getElementById("thumbnails");
          if (thumbnailList) {
            thumbnailList.scrollTop = 0;
            thumbnailList.scrollLeft = 0;
          }
          spinning.value = false;
          if (res.data.isEnd && res.data.delPage.length != 0) {
            let delpage = res.data.delPage.sort(function (a: any, b: any) {
              return b - a;
            });
            delpage.forEach((ele: any) => {
              slideList.value.splice(ele, 1);
              slidesStore.setSlideList(slideList.value);
              slidesStore.setSlides(slideList.value);
            });
          }
        }, bandingSpeed.value * maxEleLen * (objIdx + 2) + bandingSpeed.value * element.length);
      }
    }
    // if (!res.data.isEnd) {
    //   setTimeout(function () {
    //       console.log('!res.data.isEnd && stopFlag延时方法');
    //       getPagePartialContent(key)
    //       slidesStore.slideIndex = 0
    //       mainStore.setGenerateState(false)//选中元素时是否有工具栏
    //       mainStore.setActiveElementIdList([])
    //       spinning.value = false
    //     }, bandingSpeed.value * 4 * (objIdx + 2))
    // }
  } else {
    let getPagePartialContentEnd = Math.floor(Date.now() / 1000);
    let stopFlag =
      getPagePartialContentEnd - getPagePartialContentBegin.value > 180;
    if (!res.data.isEnd && stopFlag) {
      setTimeout(function () {
        getPagePartialContent(key);
        mainStore.setGenerateState(false); //选中元素时是否有工具栏
        mainStore.setActiveElementIdList([]);
        spinning.value = false;
      }, 1500);
    }
    if (res.data.isEnd) {
      spinning.value = false;
      mainStore.setGenerateState(false); //选中元素时是否有工具栏
    }
  }
};

const onContinue = () => {
  if (waitTime.value === 0) {
    waitTime.value = 20;
    continuePptContent();
    reWaitTime();
  }
};
const { toClipboard } = useClipboard();
const setShareAuth = async (data: string) => {
  const urlSearch = window.location.search;
  // recordId.value = getQueryString('recordId', urlSearch)
  // const urlFlowId = getQueryString('flowId', urlSearch) ? getQueryString('flowId', urlSearch) : recordId.value
  const clipInfo =
    window.location.href.split("?")[0] + `?shareId=${pptId.value}`;
  let skipLink = "";
  await toClipboard(clipInfo);
  if (data == "copy") {
    message.success({
      content: () => t("public.copyTips"),
      duration: 1.5,
      style: {
        marginTop: "60px",
      },
    });
    setPptShareAuth({ userPptId: pptId.value });
    return;
  }
  message.success({
    content: () => t("public.shareLinkTips"),
    duration: 1.5,
    style: {
      marginTop: "60px",
    },
  });
  switch (data) {
    case "LinkedIn":
      skipLink = "https://www.linkedin.com/";
      break;
    case "Facebook":
      skipLink = `https://www.facebook.com/sharer/sharer.php?u=${clipInfo}`;
      break;
    case "Tiktok":
      skipLink = `https://www.tiktok.com/explore`;
      break;
    case "Twitter":
      skipLink = `https://twitter.com/intent/tweet?url=${clipInfo}`;
      break;
    case "Instagram":
      skipLink = "https://www.instagram.com/";
      break;

    default:
      // skipLink = 'https://www.baidu.com/'
      break;
  }
  if (skipLink) {
    setTimeout(() => {
      window.open(skipLink, "_blank");
    }, 1500);
  }
  // else {
  //   message.error(t('public.systemBusy'))
  // }
  setPptShareAuth({ userPptId: pptId.value });
};

const isComplete = ref(false);
function continuePptContent() {
  if (isEnd.value) {
    isComplete.value = true;
  } else if (stop.value) {
    spinning.value = true;
    stop.value = false;
    if (pptId.value && pptId.value !== "null") {
      const num = slideList.value.length / 5;
      num === index && index++;
      getSliderList(pptId.value);
    } else {
      getPptContent(key.value);
    }
  }
}
const indexArr: any = ref([]);
const bandingSpeed = ref(150);
const pptElementRender = (elements: any, needNext = true) => {
  getPagePartialContentBegin.value = Math.floor(Date.now() / 1000);
  for (let i = 0; i < elements.length; i++) {
    const element = elements[i];
    setTimeout(() => {
      createElement(element);
      if (i === elements.length - 1 && needNext) {
        mainStore.setActiveElementIdList([]);
        if (index === 0 && slideList.value[0].id !== "error") {
          // 定时器是确保setActiveElementIdList成功生成封面正确
          setTimeout(() => {
            updateCover("viewport-wrapper");
            index++;
            // 生成到第N页
            Cookies.set(key.value + "index", index + "");
            getPptContent(key.value);
          }, 1000);
        } else {
          index++;
          Cookies.set(key.value + "index", index + "");
          getPptContent(key.value);
        }
      }
      if (i === elements.length - 1 && !needNext) {
        spinning.value = false;
      }
    }, bandingSpeed.value * (i + 1));
  }
  indexArr.value.push(0);
};

const autoPicture = async (el: any, options: any) => {
  const {
    scale = 1,
    allowTaint = true,
    useCORS = true,
    width = "375",
    height = "649",
    backgroundColor = null,
  } = options;
  const canvas = await html2canvas(el, {
    scale,
    allowTaint,
    useCORS, // 是否尝试使用CORS从服务器加载图像
    width,
    height,
    backgroundColor,
  });
  return canvas.toDataURL("image/png");
};

const compressImgWidth = (img: any, width: any) => {
  // 创建canvas对象
  const canvas = document.createElement("canvas");
  const context: any = canvas.getContext("2d");
  // 获取上传的img图片对象的宽度和高度
  const { width: originWidth, height: originHeight } = img;
  // 绘制图片的宽度
  canvas.width = width;
  // 根据绘制图片的宽度，等比例计算图片的高度
  canvas.height = (originHeight * canvas.width) / originWidth;
  // 将img绘制到画布上
  context.drawImage(img, 0, 0, canvas.width, canvas.height);
  return canvas.toDataURL("image/png");
};

const base64ToFile = (base64: string) => {
  const fileName = new Date().getTime().toString();
  const arr = base64.split(",");
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], fileName, { type: "image/png" });
};

const getNewPage = (title: any, pageId: any) => {
  mainStore.setRedrawState(false);
  spinning.value = true;
  tip.value = t(`index.createPage`, [slidesStore.slideIndex + 1]);
  // const urlSearch = window.location.search
  // const urlFlowId = getQueryString('flowId', urlSearch)
  // const urlRecordId = getQueryString('recordId', urlSearch)
  // const urlParams = new URLSearchParams(window.location.search)
  // const urlFlowId = urlParams.get('flowId')
  const promptCookie = Cookies.get("ppt" + pptId.value + "prompt");
  const keyCookie = Cookies.get("ppt" + pptId.value + "key");
  getNewPageContent({
    prompt: promptCookie ? promptCookie : "prompt",
    title,
    languageName: "zhCN",
    key: keyCookie ? keyCookie : pptId.value,
  })
    .then((resContent: any) => {
      setTimeout(function () {
        getNewPageInfo(resContent.data, pageId);
      }, 1500);
    })
    .catch((err) => {
      spinning.value = false;
      mainStore.setRedrawState(false);
    })
    .then((resContent: any) => {
      setTimeout(function () {
        getNewPageInfo(resContent.data, pageId);
      }, 1500);
    })
    .catch((err) => {
      spinning.value = false;
      mainStore.setRedrawState(false);
    });
};

const getNewPageInfo = (reqKey: any, pageId: any) => {
  if (stop.value) {
    spinning.value = false;
    return;
  }

  getPageContentByKey({
    key: reqKey,
    pageId: pageId,
  })
    .then((resContent: any) => {
      if (resContent.data) {
        const msg = JSON.parse(resContent.data);
        slidesStore.updateSlide({
          id: msg.id,
          background: msg.background,
          elements: [],
        });
        slidesStore.updateSlideList({
          id: msg.id,
          background: msg.background,
          elements: [],
          title: msg.string ? msg.string : "",
        });
        pptElementRender(msg.elements, false);
        slideList.value.splice(slidesStore.slideIndex, 1, msg);
        spinning.value = false;
      } else {
        setTimeout(function () {
          getNewPageInfo(reqKey, pageId);
        }, 1500);
      }
    })
    .catch((err) => {
      spinning.value = false;
      setTimeout(function () {
        getNewPageInfo(pageId, pageId);
      }, 1500);
    });
};
var stateflag = false;
const updateHeaderImg = () => {
  console.log("mainStore===>", mainStore.isAiGenerating);
};

const base64ToUrl = (url: string) => {
  return new Promise(async (resolve, reject) => {
    const formData = new FormData();
    const targetObj = base64ToFile(url);
    formData.append("file", targetObj);
    const fileRes: any = await uploadFile(
      formData,
      key.value ? key.value : pptId.value
    );
    // if (fileRes.code == 200 && fileRes.data)
    //   resolve(fileRes.data.url || '')
    // else
    //   reject('123')
    fileRes.code == 200 && fileRes.data
      ? resolve(fileRes.data.url)
      : reject("");
  });
};
const isBase64Image = (url: string) => {
  const regex = /^data:image\/[^;]+;base64,/;
  return url.match(regex) !== null;
};
const savePptV2 = async (indexNum: any) => {
  slidesStore.setSlideList(slideList.value);
  slidesStore.slideIndex = indexNum;
  const num = slideList.value.length / 100;
  if (!slidesStore.slides.length) return;
  let userPptInfoSaveList: any = []
  let saveIndex = 0
  for (const slide of slidesStore.slides) {
    let item = JSON.parse(JSON.stringify(slide))
    if (item.background) {
      if (item.background.type === "image" && item.background.image) {
        item.background.image = item.background.image.replaceAll(
          ossUrl.value,
          ""
        );
      }
      if (!item.elements) continue;
      for (const el of item.elements) {
        if (el.type === "image" && el.src) {
          el.src = el.src.replaceAll(
            ossUrl.value,
            ""
          );
        }
      }
    }
    let data = {
      userPptId: key.value ? key.value : pptId.value,
      indexNum: saveIndex,
      content: JSON.stringify(item),
      isLast: saveIndex + 1 === slidesStore.slides.length ? true : false,
      themeId: themeId.value,
    }
    saveIndex++
    userPptInfoSaveList.push(data)
  }
  mouseenterFlag.value = true;
  rightToolShow.value = false;
  spinning.value = true;
  isEnd.value = false
  mainStore.setGenerateState(true);
  const res: any = await savePptInfoV2(userPptInfoSaveList);
  if (res.code === 200) {
    mainStore.setGenerateState(false);
    progressTimer.value = setInterval(() => {
      defaultPercent.value += num;
      slidesStore.slideIndex++;
      if (slidesStore.slideIndex == (slidesStore.slides.length - 1)) {
        spinning.value = false;
        mainStore.setGenerateState(false);
        isEnd.value = true
        clearInterval(progressTimer.value);
        slidesStore.slideIndex = 0;
        setTimeout(() => {
          updateCover('viewport-wrapper');
        }, 1);
        message.success(t(`index.saveText`));
      }
    }, 300);
  } else {
    spinning.value = false;
    mainStore.setGenerateState(false);
    isEnd.value = true
    if (res.msg) {
      message.error(res.msg);
    }
  }
};

//base64转blod文件类型
const base64ToBlob = (base64String: string, contentType: string) => {
  const base64 = base64String.split(",")[1]; // 去掉数据类型前缀，如 "data:image/png;base64,"
  const byteCharacters = atob(base64); // 将 Base64 转换为二进制字符串
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: contentType });
};

const updateCover = async (className: string) => {
  const el = document.getElementsByClassName(className);
  const width = parseInt(window.getComputedStyle(el[0]).width);
  const height = parseInt(window.getComputedStyle(el[0]).height);
  const canvas = await autoPicture(el[0], { width, height });
  const img: any = new Image();
  img.src = canvas;
  img.onload = async function () {
    const compressImg = await compressImgWidth(img, 800);
    const targetObj = base64ToBlob(compressImg, "image/png");
    const fileRes: any = await uploadFileToOSS('content', targetObj, 2,'png')
    updateImg({
      id: key.value ? key.value : pptId.value,
      img: fileRes.name,
    });
  };
};

useGlobalHotkey();
usePasteEvent();

watch(activeElementIdList, () => {
  if (activeElementIdList.value.length !== 0) mainStore.setRedrawState(false);
});

watch(
  () => [
    activeElementIdList.value.length,
    isAiGenerating.value,
    mainStore.toolbarState,
    isEnd.value,
    rightToolShow.value,
  ],
  (newVal) => {
    if ((newVal[0] && !newVal[1] && newVal[3]) || newVal[4]) {
      toolShow.value = true;
      mouseenterFlag.value = false;
    } else {
      toolShow.value = false;
    }
  }
);

function pushHistory() {
  var state = {
    title: "title",
    url: "#",
  };
  window.history.pushState(state, "title", "#");
}
pushHistory();
// 　　　　2.监听 popstate 事件
window.addEventListener(
  "popstate",
  function () {
    //doSomething
  },
  false
);

const getAuths = () => {
  getUserCanChatAndDownLoad(pptId.value)
    .then((res: any) => {
      if (!window.location.href.includes("admin")) {
        isVip.value = res.data.isVip;
      }
      canChat.value = res.data.chat;
      canDownLoad.value = res.data.dl;
    })
    .catch((err: any) => { });
};

const openTemplates = ref<boolean>(false);
const pageNum = ref(1);
const templatePageSize = ref(16);
const templates = ref<any>([]);
const getTemplateListHandle = () => {
  var tenantId = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') as string).tenantId : 6;
  const params = styleId.value
    ? {
      pageNum: pageNum.value,
      pageSize: templatePageSize.value,
      sytleId: styleId.value,
      tenantId
    }
    : {
      pageNum: pageNum.value,
      pageSize: templatePageSize.value,
      tenantId
    };
  getTemplateList(params)
    .then((res: any) => {
      if (res.data.length == 0) {
        pageNum.value = 1;
        getTemplateListHandle();
        return
      }
      res.data.forEach((item: any) => {
        item.showImg = (item.ossFlag && item.ossFlag == 2 && !item.showImg.includes('https://')) ? `${ossUrl.value}${item.showImg}` : item.showImg
      })
      if (res.total <= templates.value.length) {
        noMore.value = true;
      }
      templates.value.push(...res.data);
      if (pageNum.value == 1) templateId.value = templates.value[0].id;
    })
    .catch((err: any) => { });
};
const selectTemplateIdx = ref(0);
const changeTemplateOver = ref(false);
const changeTemplateTip = ref("");
const selectTemplateHandle = (id: any, e: any, index: number) => {
  templateId.value = id;
  selectTemplateIdx.value = index;
};

const templateId = ref(0); //预选id
const changeTemplateDiaOkFun = ref(200);
const goChange = () => {
  goChangeMsgModalShow.value = false;
  if (!recordId.value) {
    // const urlSearch = window.location.search
    // const urlParams = new URLSearchParams(window.location.search)
    // recordId.value = getQueryString('recordId', urlSearch) || getQueryString('flowId', urlSearch)
    recordId.value = pptId.value;
  }
  let operInputParam = {
    id: pptId.value,
    themeId: templateId.value,
  };
  sendClickData(19, 19, "", JSON.stringify(operInputParam));
  changeTemplate({
    id: pptId.value,
    themeId: templateId.value,
  })
    .then((res: any) => {
      changeTemplateDiaOkFun.value = res.code;
      if (res.data == "3") {
        mouseenterFlag.value = true;
        themeId.value = templateId.value;
        getTemplateLayouts();
        selectAllSlide();
        deleteSlide();
        slideList.value = [];
        rightToolShow.value = false;
        slidesStore.setSlides([]);
        slidesStore.slideIndex = 0;
        saveHeadImg.value = false;
        openTemplates.value = false;
        bandingSpeed.value = 150;
        index = 0;
        sessionId.value = sessionId.value + 1;
        spinning.value = true;
        initPptNew();
      } else {
        changeTemplateOver.value = true;
        changeTemplateTip.value = res.msg;
      }
    })
    .catch((err: any) => { });
};

const changeTemplateHandle = () => {
  mouseenterFlag.value = false;
  openTemplates.value = true;
  if (templates.value.length == 0) getTemplateListHandle();
};
const scrollTimer = ref<number>();
const noMore = ref(false);
const handleScroll = (e: any) => {
  let el = e.currentTarget;
  if (scrollTimer) {
    clearTimeout(scrollTimer.value);
  }
  scrollTimer.value = setTimeout(() => {
    if (el.scrollHeight - (el.scrollTop + el.clientHeight) < 500) {
      pageNum.value = pageNum.value + 1;
      getTemplateListHandle();
    }
  }, 200);
  /*scrollTimer.value = setTimeout(() => {
    let myWidth = el.scrollWidth - el.clientWidth
    let needWidth = myWidth - el.scrollLeft
    if (el.scrollLeft >= myWidth || needWidth < 5) {
      //滚动到了右边
      // if (noMore.value) {//无限循环
      //   pageNum.value = 1
      // } else {
        pageNum.value = pageNum.value + 1;
      // }
      getTemplateListHandle()
    }
  }, 200);*/
};
const toPricing = () => {
  window.parent.location.href = "/pricing?d=3";
};
const openPreview = ref(false);
const previewImgs = ref();
const openPreviewHandle = (data: any) => {
  let preview = data.preview;
  openPreview.value = true;
  previewImgs.value = JSON.parse(preview);
  previewImgs.value.forEach((ele: any, index: number) => {
    previewImgs.value[index] = (data.ossFlagPreview && data.ossFlagPreview == 2 && !ele.includes('https://')) ? ossUrl.value + ele : ele;
  })
};

const closeChangeTemplate = () => {
  openTemplates.value = false;
  mouseenterFlag.value = true;
};

const changeThemeStyle = (data: any) => {
  styleId.value = data;
  pageNum.value = 1;
  templates.value = [];
  getTemplateListHandle();
};
const themeList = ref([
  {
    id: "",
    name: "All",
  },
]);
const styleId = ref("");
const getThemeList = () => {
  let lang = Cookies.get("lang") || "en";
  getPptThemeStyleByLanguage(lang).then((res: any) => {
    if (res.code == 200 && res.data.length) {
      themeList.value = themeList.value.concat(res.data);
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (spinning.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
        : _createCommentVNode("", true),
      (errSpinning.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, _toDisplayString(tip.value), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "layout-content",
        ref_key: "layoutContent",
        ref: layoutContent
      }, [
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", {
              class: _normalizeClass([
            _unref(isPc) ? 'new_layout_content_left' : 'new_layout_content_bottom',
          ])
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(Thumbnails)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass([
                _unref(isPc)
                  ? 'new_layout_content_rightTab'
                  : 'new_layout_content_topTab',
              ]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (mouseenterFlag.value = false))
                }, [
                  _createVNode(_unref(LeftOutlined))
                ], 2)
              ])
            ], 2),
            _withDirectives(_createElementVNode("div", {
              class: "new_layout_content_rightTab",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (mouseenterFlag.value = false))
            }, [
              _createVNode(_unref(LeftOutlined))
            ], 512), [
              [_vShow, _unref(isPc)]
            ])
          ], 512), [
            [_vShow, mouseenterFlag.value]
          ]),
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass([
          _unref(isPc)
            ? 'new_layout_content_leftTab'
            : 'new_layout_content_bottomTab',
        ]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (mouseenterFlag.value = true))
          }, [
            _createVNode(_unref(RightOutlined))
          ], 2), [
            [_vShow, !mouseenterFlag.value]
          ]),
          _createVNode(CanvasTool, {
            class: "center-top",
            isEnd: isEnd.value,
            isStop: stop.value,
            waitTime: waitTime.value,
            onSave: _cache[3] || (_cache[3] = ($event: any) => (savePptV2(0))),
            recordId: recordId.value,
            paid: paid.value,
            canDownLoad: canDownLoad.value,
            isVip: isVip.value,
            onChangeTemplateHandle: changeTemplateHandle,
            onContinueContent: onContinue,
            onSetShareAuth: setShareAuth
          }, null, 8, ["isEnd", "isStop", "waitTime", "recordId", "paid", "canDownLoad", "isVip"]),
          (_unref(isPc))
            ? (_openBlock(), _createBlock(Canvas, {
                key: 0,
                onChangeToolShow: changeToolShow,
                class: "center-body",
                userSelectPreCatalogueId: userSelectPreCatalogueId.value,
                isEnd: isEnd.value,
                paid: paid.value,
                canChat: canChat.value,
                isVip: isVip.value,
                style: _normalizeStyle({
            height: `calc(100% - ${50}px)`,
            'margin-left': mouseenterFlag.value ? '220px' : '0px',
            'margin-right': toolShow.value ? '345px' : '70px',
          })
              }, null, 8, ["userSelectPreCatalogueId", "isEnd", "paid", "canChat", "isVip", "style"]))
            : (_openBlock(), _createBlock(Canvas, {
                key: 1,
                onTouchstart: _cache[4] || (_cache[4] = ($event: any) => (pptTouchstart($event))),
                onTouchend: _cache[5] || (_cache[5] = ($event: any) => (pptTouchend($event))),
                class: "center-body",
                userSelectPreCatalogueId: userSelectPreCatalogueId.value,
                isEnd: isEnd.value,
                paid: paid.value,
                canChat: canChat.value,
                isVip: isVip.value,
                style: _normalizeStyle({
            height: mouseenterFlag.value ? 'calc(100% - 210px)' : 'calc(100% - 80px)',
            width: '100%',
            'margin-bottom': mouseenterFlag.value ? '80px' : '0px',
          })
              }, null, 8, ["userSelectPreCatalogueId", "isEnd", "paid", "canChat", "isVip", "style"]))
        ]),
        _createVNode(NewCanvasTool, {
          rightToolShow: rightToolShow.value,
          onChangeToolShow: changeToolShow
        }, null, 8, ["rightToolShow"]),
        _withDirectives(_createElementVNode("div", {
          class: "drag-box",
          draggable: "true",
          onDragstart: _cache[6] || (_cache[6] = ($event: any) => (dragstart($event))),
          onDragend: _cache[7] || (_cache[7] = ($event: any) => (dragend($event))),
          onTouchstart: _cache[8] || (_cache[8] = ($event: any) => (touchstart($event))),
          onTouchmove: _cache[9] || (_cache[9] = ($event: any) => (touchmove($event))),
          onTouchend: _cache[10] || (_cache[10] = ($event: any) => (touchend($event))),
          style: _normalizeStyle(`right:${elRight.value}px;top:${elTop.value}px`)
        }, [
          _createVNode(_Transition, { name: "slide-fade" }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(NewToolbar, {
                class: _normalizeClass(["layout-element-item", { 'can-move': canMove.value }])
              }, null, 8, ["class"]), [
                [_vShow, !_unref(isAiGenerating) &&
            (backgroundEditSate.value || _unref(activeElementIdList).length)
            ]
              ])
            ]),
            _: 1
          })
        ], 36), [
          [_vShow, _unref(isPc)]
        ]),
        _createVNode(_Transition, { name: "slide-fade" }, {
          default: _withCtx(() => [
            (_unref(redrawFlag))
              ? (_openBlock(), _createBlock(Redraw, {
                  key: 0,
                  class: "layout-element-item",
                  style: {"right":"20px","height":"80vh","box-shadow":"0px 0px 50px 8px rgba(0, 0, 0, 0.1)"},
                  onClick: getNewPage
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 512),
      (isSaveFlag.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_unref(Progress), {
              "stroke-color": "#5230f2",
              type: "circle",
              percent: Number(defaultPercent.value.toFixed(1))
            }, null, 8, ["percent"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_unref(showSelectPanel))
      ? (_openBlock(), _createBlock(SelectPanel, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_unref(Modal), {
      visible: !!_unref(dialogForExport),
      footer: null,
      centered: "",
      closable: false,
      width: 550,
      destroyOnClose: "",
      onCancel: _cache[11] || (_cache[11] = ($event: any) => (closeExportDialog()))
    }, {
      default: _withCtx(() => [
        _createVNode(ExportDialog)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(Modal), {
      visible: isComplete.value,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((isComplete).value = $event)),
      title: "Complete",
      onOk: _cache[13] || (_cache[13] = ($event: any) => (isComplete.value = false)),
      cancelText: _unref(t)(`public.cancel`),
      "ok-text": "OK",
      centered: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_unref(t)(`public.generateSuccess`)), 1)
      ]),
      _: 1
    }, 8, ["visible", "cancelText"]),
    _createVNode(_unref(Modal), {
      visible: tokenOver.value,
      "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((tokenOver).value = $event)),
      title: _unref(t)(`public.systemMsg`),
      onOk: _cache[15] || (_cache[15] = ($event: any) => (tokenOver.value = false)),
      cancelText: _unref(t)(`public.cancel`),
      "ok-text": "OK",
      centered: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(tip.value), 1)
      ]),
      _: 1
    }, 8, ["visible", "title", "cancelText"]),
    _createVNode(_unref(Modal), {
      visible: changeTemplateOver.value,
      "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((changeTemplateOver).value = $event)),
      title: _unref(t)(`public.systemMsg`),
      cancelText: _unref(t)(`public.cancel`),
      onOk: _cache[17] || (_cache[17] = ($event: any) => (
    changeTemplateDiaOkFun.value == 700 ? toPricing : (changeTemplateOver.value = false)
    )),
      centered: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(changeTemplateTip.value), 1)
      ]),
      _: 1
    }, 8, ["visible", "title", "cancelText"]),
    _createVNode(_unref(Modal), {
      style: {"width":"400px"},
      visible: goChangeMsgModalShow.value,
      "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((goChangeMsgModalShow).value = $event)),
      centered: "",
      closable: false,
      destroyOnClose: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", {
            class: "btn",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (goChangeMsgModalShow.value = false))
          }, _toDisplayString(_unref(t)(`public.cancel`)), 1),
          _createElementVNode("div", {
            class: "btn primary",
            onClick: goChange
          }, _toDisplayString(_unref(t)(`index.sBtn`)), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_unref(t)(`public.templateChangeTips`)), 1)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(Modal), {
      visible: openTemplates.value,
      "onUpdate:visible": _cache[24] || (_cache[24] = ($event: any) => ((openTemplates).value = $event)),
      class: "templates-modal",
      width: "70vw",
      closable: false,
      centered: true,
      footer: null,
      maskClosable: false,
      style: {"border":"1px solid #999","border-radius":"0.75rem","overflow":"hidden","min-width":"325px","background":"#eff1f5"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, _toDisplayString(nowSize.value > 1024
            ? _unref(t)(`public.templateChoose`)
            : _unref(t)(`public.templateChooseShort`)), 1),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: "btn",
              onClick: closeChangeTemplate
            }, _toDisplayString(_unref(t)(`public.close`)), 1),
            _createElementVNode("div", {
              class: "btn primary-color",
              onClick: _cache[20] || (_cache[20] = ($event: any) => (goChangeMsgModalShow.value = true))
            }, [
              _createTextVNode(_toDisplayString(_unref(t)(`public.replace`)) + " ", 1),
              _hoisted_15
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(themeList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              onClick: ($event: any) => (changeThemeStyle(item.id)),
              class: _normalizeClass(['category-item', styleId.value == item.id ? 'category-active' : ''])
            }, _toDisplayString(item.name), 11, _hoisted_17))
          }), 128))
        ]),
        _hoisted_18,
        _createElementVNode("div", {
          class: "templates",
          onScroll: handleScroll
        }, [
          _createVNode(_unref(Modal), {
            visible: openPreview.value,
            "onUpdate:visible": _cache[22] || (_cache[22] = ($event: any) => ((openPreview).value = $event)),
            class: "preview-modal",
            footer: null,
            style: {"min-width":"350px","width":"40vw","padding":"16px"},
            closable: false,
            centered: true
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "modal-close",
                onClick: _cache[21] || (_cache[21] = ($event: any) => (openPreview.value = false))
              }, _hoisted_20),
              _createElementVNode("div", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(previewImgs.value, (item, index) => {
                  return _withDirectives((_openBlock(), _createElementBlock("img", {
                    key: 'pv' + index,
                    style: {"width":"100%"}
                  })), [
                    [_directive_lazy, item]
                  ])
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["visible"]),
          _createVNode(_unref(Row), {
            style: {"width":"100%"},
            gutter: [5, 5]
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templates.value, (item, index) => {
                return (_openBlock(), _createBlock(_unref(Col), {
                  style: {"height":"fit-content"},
                  xs: 24,
                  sm: 24,
                  md: 12,
                  lg: 12,
                  xl: 8,
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(selectTemplateIdx.value == index
          ? 'template-item template-item-active'
          : 'template-item'
          ),
                      onClick: ($event: any) => (selectTemplateHandle(item.id, $event, index))
                    }, [
                      _withDirectives(_createElementVNode("img", null, null, 512), [
                        [_directive_lazy, item.showImg]
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        (_unref(isPc))
                          ? (_openBlock(), _createBlock(_unref(Button), {
                              key: 0,
                              size: "small",
                              class: "preview-btn",
                              onClick: ($event: any) => (openPreviewHandle(item))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)(`public.preView`)), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true),
                        _createVNode(_unref(Button), {
                          size: "small",
                          class: "preview-btn",
                          onClick: _cache[23] || (_cache[23] = ($event: any) => (goChangeMsgModalShow.value = true))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)(`public.replace`)), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ], 10, _hoisted_22)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ], 32)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})